import { TabView, TabPanel } from 'primereact/tabview';
import React, { useState } from 'react';
import { RecordsDashboard } from '../../features/correctiveActions/caRecords/RecordsDashboard';
import { CaHcRecord } from '../../features/correctiveActions/type';
import { RecordView } from '../../features/correctiveActions/caRecords/RecordView';
import { HCRecordsCA } from '../../utils/typeConstants';

export const Records = () => {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(HCRecordsCA.Records);
    const [caHcRecord, setCaHcRecord] = useState<CaHcRecord>();


    return (
        <div>
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeTabIndex}
                                onTabChange={(e) => {
                                    setActiveTabIndex(e.index);
                                }}
                            >
                                <TabPanel header="Records">
                                    <RecordsDashboard
                                        setCaHcRecord={setCaHcRecord}
                                        setActiveTabIndex={setActiveTabIndex}

                                    />
                                </TabPanel>
                                {
                                    activeTabIndex === HCRecordsCA.RecordView && (
                                        <TabPanel header="View">
                                            <RecordView
                                                type={'view'}
                                                caHcRecord={caHcRecord}
                                                setActiveTabIndex={setActiveTabIndex}
                                            />
                                        </TabPanel>
                                    )
                                }
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
